import { bindRequestLogic } from './utils'
import MailTemplateTypes from '../actionTypes/mailTemplate'
import { mailTemplateAPI } from '../api'

const getMailTemplates = bindRequestLogic({
  clientFunc: mailTemplateAPI.getMailTemplates,
  type: MailTemplateTypes.GET_MAIL_TEMPLATES_REQUEST,
  successType: MailTemplateTypes.GET_MAIL_TEMPLATES_SUCCESS,
  failType: MailTemplateTypes.GET_MAIL_TEMPLATES_FAILED,
  isQueryParam: true,
  modelName: 'mailTemplates'
})

const addMailTemplate = bindRequestLogic({
  clientFunc: mailTemplateAPI.addMailTemplate,
  type: MailTemplateTypes.ADD_MAIL_TEMPLATE_REQUEST,
  successType: MailTemplateTypes.ADD_MAIL_TEMPLATE_SUCCESS,
  failType: MailTemplateTypes.ADD_MAIL_TEMPLATE_FAILED
})

const updateMailTemplate = bindRequestLogic({
  clientFunc: mailTemplateAPI.updateMailTemplate,
  type: MailTemplateTypes.UPDATE_MAIL_TEMPLATE_REQUEST,
  successType: MailTemplateTypes.UPDATE_MAIL_TEMPLATE_SUCCESS,
  failType: MailTemplateTypes.UPDATE_MAIL_TEMPLATE_FAILED
})

const getMailTemplate = bindRequestLogic({
  clientFunc: mailTemplateAPI.getMailTemplateDetail,
  type: MailTemplateTypes.GET_MAIL_TEMPLATE_DETAIL_REQUEST,
  successType: MailTemplateTypes.GET_MAIL_TEMPLATE_DETAIL_SUCCESS,
  failType: MailTemplateTypes.GET_MAIL_TEMPLATE_DETAIL_FAILED,
  modelName: 'mailTemplate'
})

const deleteMailTemplate = bindRequestLogic({
  clientFunc: mailTemplateAPI.deleteMailTemplate,
  type: MailTemplateTypes.DELETE_MAIL_TEMPLATE_REQUEST,
  successType: MailTemplateTypes.DELETE_MAIL_TEMPLATE_SUCCESS,
  failType: MailTemplateTypes.DELETE_MAIL_TEMPLATE_FAILED
})

const upsertMailTemplateTranslation = bindRequestLogic({
  clientFunc: mailTemplateAPI.upsertMailTemplateTranslation,
  type: MailTemplateTypes.UPSERT_MAIL_TEMPLATE_TRANSLATION_REQUEST,
  successType: MailTemplateTypes.UPSERT_MAIL_TEMPLATE_TRANSLATION_SUCCESS,
  failType: MailTemplateTypes.UPSERT_MAIL_TEMPLATE_TRANSLATION_FAILED
})

const getMailTemplateTokens = bindRequestLogic({
  clientFunc: mailTemplateAPI.getMailTemplateTokens,
  type: MailTemplateTypes.GET_MAIL_TEMPLATE_TOKENS_REQUEST,
  successType: MailTemplateTypes.GET_MAIL_TEMPLATE_TOKENS_SUCCESS,
  failType: MailTemplateTypes.GET_MAIL_TEMPLATE_TOKENS_FAILED,
  isQueryParam: true,
  modelName: 'tokens'
})

export default [
  getMailTemplates,
  addMailTemplate,
  updateMailTemplate,
  getMailTemplate,
  deleteMailTemplate,
  upsertMailTemplateTranslation,
  getMailTemplateTokens
]
